import { BCMSRecord, useBCMSContext, useParams, useRoute } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRowView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIAmountInput, UIButton, UICheckbox } from "components/ui";
import Classes, { Account, UserAccount } from "model";

import "./styles.css";

export default function AddAlertBelowThresholdContent(props) {
    const navigate = useRoute();
    const { id } = useParams();

    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const account = Account.initByType(id) ?? Account.initAll()[0];
    const userAccounts = UserAccount.initAll() ?? [];

    const { phones, emails } = userAccounts.reduce((result, { workPhoneNumber, emailAddress, id }) => {
        result.phones.push(<UICheckbox label={ workPhoneNumber } />);
        result.emails.push(<UICheckbox label={ emailAddress } value={ id === "0" } />);

        return result;
    }, { phones: [], emails: [] })

    const onCancel = evt => navigate("/advancedAlerts/selectAccount");
    const onSubmit = evt => navigate("/advancedAlerts/manageAlerts", { state: { added: true } });

    return (
        <div className="add-alert-below-threshold-content">
            <p className="page-subtitle">Account Balance Below Threshold</p>

            <FormContainer className="small-form-width">
                <FormRowView>
                    <div className="flex-container flex-vertical account-details">
                        <p className="account-name">{ account.nickname }</p>
                        <p className="account-number">{ account.number }</p>
                        <p className="account-amount">{ account.currentBalance.format() }</p>
                    </div>
                </FormRowView>

                <FormRowView text="Amount *">
                    <UIAmountInput />
                </FormRowView>

                <FormRowView text="Recipients *" className="recipients-container">
                    <div className="flex-container flex-vertical">
                        { emails }
                        { phones }
                    </div>
                </FormRowView>

                <FormButtonRow>
                    <UIButton className="secondary-button" text="Cancel" onClick={ onCancel } />
                    <UIButton className="primary-button" text="Submit" onClick={ onSubmit } />
                </FormButtonRow>
            </FormContainer>
        </div>
    );
}